import React from 'react'
import './quotationTogglebutton.scss'

const quotationToggleButton = (props) => {
    return(
        <button className="wd-header__quotation-toggle-button" onClick={props.click}>devis gratuit</button>
    )
}

export default quotationToggleButton